<template>
  <div>
    <base-dropdown
      ref="dropdown"
      class="nav-link pr-0"
      :position="'right'"
      :customDrop="true">
      <div class="media align-items-center custom-media-nav-size" slot="title">
        <div class="media-body ml-2 d-none d-md-block d-lg-block pr-1">
          <span class="mb-0 text-sm font-weight-bold"
            >{{ this.$USER_LOGIN.get().details.name }}<br />
          </span>
          <!-- <p class="mb-0 small">{{ this.$USER_LOGIN.get().details.role }}</p> -->
        </div>
        <span class="b-avatar badge-primary rounded-circle">
          <span class="b-avatar-text">
            <span>{{ firstTitleName }}</span>
          </span>
        </span>
        <i class="fas fa-caret-down pl-2"></i>
      </div>
      <template>
        <div class="dropdown-header noti-title dropdown-menu-left">
          <a
            class="dropdown-item p-0"
            :class="visibleShopDetails ? null : 'collapsed'"
            :aria-expanded="visibleShopDetails ? 'true' : 'false'"
            aria-controls="collapse-shop-detail"
            @mouseover="visibleShopDetails = true"
            @mouseleave="visibleShopDetails = false">
            <div class="row">
              <div class="col-12 col-lg-8 col-xl-8 col-md-8">
                <template v-if="this.$USER_LOGIN.get().isAdmin">
                  <h4>{{ this.$USER_LOGIN.get().details.shop_name }}</h4>
                  <h6>{{ this.$USER_LOGIN.get().details.email }}</h6>
                </template>
                <template v-else>
                  <h4 class="pt-3">
                    {{ this.$USER_LOGIN.get().details.email }}
                  </h4>
                </template>
              </div>
              <div class="col-12 col-lg-4 col-xl-4 col-md-4">
                <i
                  class="fas fa-angle-right fa-lg pt-4 pl-5"
                  v-if="!visibleShopDetails"></i>
                <i class="fas fa-angle-down fa-lg pt-4 pl-5" v-else></i>
              </div>
            </div>
          </a>
        </div>
        <b-collapse
          id="collapse-shop-detail"
          v-model="visibleShopDetails"
          class="mt-2">
          <div class="dropdown-divider"></div>
          <!-- <BaseShopDetails></BaseShopDetails> -->
        </b-collapse>
        <div class="dropdown-divider"></div>
        <template v-if="this.$USER_LOGIN.get().isAdmin">
          <div class="dropdown-divider"></div>
        </template>
        <router-link to="/logout" class="dropdown-item">
          <!-- <Icon icon="mdi-exit-to-app"/> -->
          <i class="fas fa-sign-out-alt text-color-wallet"></i>
          <span class="text-color-wallet">ออกจากระบบ</span>
        </router-link>
      </template>
    </base-dropdown>
  </div>
</template>

<script>
import BaseShopDetails from "@/components/BaseShopDetails";
export default {
  name: "DropDownShop",
  components: {
    BaseShopDetails,
  },
  data() {
    return {
      visibleShopDetails: false,
    };
  },
  computed: {
    firstTitleName() {
      return this.$USER_LOGIN.get().details.name.slice(0, 1).toUpperCase();
    },
  },
};
</script>
